module.exports = __webpack_public_path__ + "img/slider_1.8626d7a7.jpg";